/**
 * Bouwt één EventResults-document voor een geregistreerde output.
 *
 * Deelnemers horen in `Participants` op ditzelfde document. De oude vorm —
 * een tweede document met `Type: 'participants'` — is vervallen: deelnemers
 * worden aan een output van een activiteit gekoppeld, niet aan de activiteit
 * als geheel.
 *
 * SPIEGEL: functions/personas/buildOutputEventResult.js bevat dezelfde functie
 * voor de nachtklus. Wijzig ze altijd samen — deze twee schrijvers uit elkaar
 * laten lopen is precies wat de dubbele registraties veroorzaakte. Beide
 * testbestanden leggen dezelfde verwachte vorm vast, dus drift laat de test
 * van de afwijkende kant vallen.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {object} args
 * @param {string} args.id - Zakelijke ID van dit document
 * @param {string} args.sessionId - Groepeert de regels van één registratie
 * @param {string} args.compagnyId - Tenant
 * @param {string} args.outputID - De geregistreerde output
 * @param {string} args.activityId - Activiteit waar de output onder valt
 * @param {string} args.eventFormId - Formulier waar de registratie bij hoort
 * @param {string} [args.fieldId] - Het outputs-veld op dat formulier
 * @param {*} args.timestamp - Tijdstempel (serverTimestamp of Timestamp)
 * @param {number} [args.value] - Aantal eenheden
 * @param {number} [args.position] - Volgorde binnen de output
 * @param {string[]} [args.participants] - Deelnemers bij deze output
 * @param {string} [args.personaId] - Deelnemer waarvoor de regel is gemaakt
 * @param {string} [args.user] - Auteur; 'Deccos' voor de nachtklus
 * @param {string} [args.scheduleID] - Roosterregel (alleen nachtklus)
 * @param {string} [args.dateKey] - Dag als YYYY-MM-DD (alleen nachtklus)
 * @returns {object}
 */
const buildOutputEventResult = ({
    id,
    sessionId,
    compagnyId,
    outputID,
    activityId,
    eventFormId,
    fieldId = '',
    timestamp,
    value = 1,
    position = 1,
    participants = [],
    personaId = '',
    user = '',
    scheduleID = '',
    dateKey = '',
}) => ({
    Compagny: compagnyId,
    CompagnyID: compagnyId,
    ID: id,
    Value: value,
    Timestamp: timestamp,
    OutputID: outputID,
    ActivityID: activityId,
    EventID: eventFormId,
    Position: position,
    Type: 'outputs',
    User: user,
    SessionID: sessionId,
    FieldID: fieldId || '',
    Participants: Array.from(new Set((participants || []).filter(Boolean))),
    PersonaID: personaId,
    ScheduleID: scheduleID,
    DateKey: dateKey,
})

export default buildOutputEventResult
